import React from 'react';
import { Chip, Box, alpha } from '@mui/material';
import useDesignTokens from './useDesignTokens';

// Reads categoryColors[mode] from the theme by default. `category` is the
// semantic key (packaging/safety/office/equipment/foodBev/cleaning/none);
// `label` is the already-translated category name.
//
// Real categories in this app are admin-created with an arbitrary chosen
// colour (CHANGES.md §2.8: "admin can still pick any colour") — they don't
// map onto the design's fixed 7-key palette. `color` is an escape hatch for
// exactly that case: pass the category's own stored colour and it's used
// only when `category` doesn't resolve to one of the design's own keys.
// Prefer `category` whenever a real semantic key applies.
const CategoryPill = ({ category, color, label, sx }) => {
  const { categoryColors } = useDesignTokens();
  const semanticTone = categoryColors[category];
  // No pre-picked "ink" shade exists for an arbitrary admin colour, and using
  // the raw colour as text over its own light tint risks poor contrast for
  // light hues — fall back to the theme's own body text colour instead,
  // keeping only the dot/tint at the admin's actual chosen colour.
  const tone = semanticTone || (color
    ? { dot: color, tint: alpha(color, 0.14), ink: 'text.primary' }
    : categoryColors.none);

  return (
    <Chip
      icon={<Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: tone.dot, ml: '10px' }} />}
      label={label}
      sx={{
        bgcolor: tone.tint,
        color: tone.ink,
        '& .MuiChip-icon': { color: 'inherit' },
        ...sx,
      }}
    />
  );
};

export default CategoryPill;
